// Selectors
export const saveLocal = (state): String => state.auth.saveLocal;
export const uid = (state): String => state.auth.auth.uid;
export const email = (state): String => state.auth.auth.email;
export const accessToken = (state): String => state.auth.auth.accessToken;

export const authObj = (state): String => state.auth;
export const isLoggedIn = (state): Boolean => state.auth.auth.uid !== '' && state.auth.auth.email !== '' && state.auth.auth.accessToken !== '';